"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var component_icon_font_1 = __importDefault(require("@rotaryintl/component-icon-font"));

var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));

var hook_use_on_click_outside_1 = __importDefault(require("@rotaryintl/hook-use-on-click-outside"));

var classnames_1 = __importDefault(require("classnames"));

var link_component_1 = require("../link/link.component");

var LinkDropdown = function (props) {
  var _a;

  var _b, _c, _d, _e, _f, _g;

  var _h = (0, react_1.useState)(false),
      isOpen = _h[0],
      setIsOpen = _h[1];

  var dropdownRef = (0, react_1.useRef)(null);
  var triggerBtnRef = (0, react_1.useRef)(null);
  var panelBtnRef = (0, react_1.useRef)(null);
  (0, hook_use_on_click_outside_1.default)(dropdownRef, function () {
    return setIsOpen(false);
  });
  (0, react_1.useEffect)(function () {
    var _a, _b;

    if (triggerBtnRef.current !== document.activeElement && panelBtnRef.current !== document.activeElement) {
      return;
    }

    if (isOpen) {
      (_a = panelBtnRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    } else {
      (_b = triggerBtnRef.current) === null || _b === void 0 ? void 0 : _b.focus();
    }
  }, [isOpen]);
  var size = (_b = props.size) !== null && _b !== void 0 ? _b : 'sm';
  var border = (_c = props.border) !== null && _c !== void 0 ? _c : false;
  var elevation = (_d = props.elevation) !== null && _d !== void 0 ? _d : 'floating';
  var panelWidth = (_e = props.panelWidth) !== null && _e !== void 0 ? _e : 'content';
  var openDirection = (_f = props.openDirection) !== null && _f !== void 0 ? _f : 'down';
  var bem = (0, hook_use_bem_classes_1.default)('rwc-link-dropdown');
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: bem(),
    ref: dropdownRef
  }, {
    children: [(0, jsx_runtime_1.jsxs)("button", __assign({
      type: "button",
      "aria-haspopup": "menu",
      "aria-expanded": isOpen,
      id: "".concat(props.metadataName, "-button"),
      "aria-controls": "".concat(props.metadataName, "-menu"),
      className: props.buttonClasses,
      ref: triggerBtnRef,
      onClick: function () {
        return setIsOpen(!isOpen);
      }
    }, {
      children: [(0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
        type: props.icon,
        size: "16"
      }), (0, jsx_runtime_1.jsx)("span", {
        children: props.label
      }), (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
        type: "fas-angle-down",
        size: "16"
      })]
    })), (0, jsx_runtime_1.jsxs)("div", __assign({
      className: (0, classnames_1.default)(bem('panel'), bem('panel', "s-".concat(elevation)), bem('panel', "w-".concat(panelWidth)), bem('panel', openDirection), (_a = {}, _a[bem('panel', 'open')] = isOpen, _a[bem('panel', 'border')] = border, _a))
    }, {
      children: [(0, jsx_runtime_1.jsxs)("button", __assign({
        type: "button",
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        "aria-controls": "".concat(props.metadataName, "-menu"),
        ref: panelBtnRef,
        className: (0, classnames_1.default)(bem('panel-button'), bem('panel-button', openDirection), bem('panel-button', size)),
        onClick: function () {
          return setIsOpen(!isOpen);
        }
      }, {
        children: [(0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
          type: props.icon,
          size: "16"
        }), (0, jsx_runtime_1.jsx)("span", {
          children: props.label
        }), (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
          type: "fas-angle-up",
          size: "16"
        })]
      })), props.links && props.links.length > 0 && (0, jsx_runtime_1.jsx)("ul", __assign({
        role: "menu",
        id: "".concat(props.metadataName, "-menu"),
        "aria-labelledby": "".concat(props.metadataName, "-button")
      }, {
        children: (_g = props.links) === null || _g === void 0 ? void 0 : _g.map(function (link) {
          return (0, jsx_runtime_1.jsx)("li", {
            children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({}, link, {
              role: "menuitem",
              onClick: props.onChange !== undefined ? function () {
                if (props.onChange) {
                  props.onChange(link);
                }
              } : undefined,
              className: (0, classnames_1.default)(bem('panel-item'), bem('panel-item', size), bem('panel-item', openDirection))
            }, {
              children: props.displaySelectedCheckmark && link.linkText === props.label && (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
                type: "fas-check",
                size: "16"
              })
            }))
          }, "".concat(bem('panel-item'), "-").concat(link.linkText, "-").concat(link.linkUrl));
        })
      }))]
    }))]
  }));
};

exports.default = LinkDropdown;